export const isNullOrUndefinedOrEmpty = (item: string | number): boolean => {
    return item === null || item === undefined || item === ""
}
